
import { Button, Row, Col, Form, Container } from 'react-bootstrap';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { authActions } from '_store';
import { toast } from 'react-toastify';
import PasswordInput from './PasswordInput';

export const SignIn = () => {

  const dispatch = useDispatch();
  const [showForm, setShowForm] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [authLoading, setAuthLoading] = useState(false);
  const [forgotEmail, setForgotEmail] = useState('');
  const [errmsg, setErrmsg] = useState('');
  const [saveLoading, setSaveLoading] = useState(false);
  const [messageColor, setMessageColor] = useState('text-danger');
  const url = process.env.REACT_APP_URL;
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleForgotPassword = () => setShowForgotPassword(true);
  const handleSignIn = () => setShowForgotPassword(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaveLoading(true);
    try {
      setErrmsg('');
      const response = await fetch(`${url}/users/reset`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: forgotEmail })
      });
      const result = await response.json();
      if (!response.ok || !result.resetToken) {
        throw new Error(result.message || result.Error || 'Unable to request a password reset.');
      }
      const response2 = await fetch(`${process.env.REACT_APP_MAILSERVER}/html`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json;charset=utf-8' },
        body: JSON.stringify({
          appMailUser: process.env.REACT_APP_MAILUSER,
          appMailPass: process.env.REACT_APP_MAILPASS,
          toList: forgotEmail,
          subject: `${process.env.REACT_APP_TITLE} password reset`,
          html: `
            <h3>${process.env.REACT_APP_TITLE} password reset</h3>
            <p>You are receiving this because you (or someone else) have requested the reset of the password for your account.</p>
            <p>If you did not request this, please ignore this email and your password will remain unchanged.</p>
            <p>Please click on the following link:</p>
            <p><a href="${window.location.protocol}//${window.location.host}/reset/${result.resetToken}">Click here</a></p>
            <p>or copy and paste in a new tab of your web browser the following link to complete the process: ${window.location.protocol}//${window.location.host}/reset/${result.resetToken}</p>
            <p><small style="color:red">the link is valid only one hour since the request was made</small></p>
          `
        })
      });
      const result2 = await response2.json();
      if (result2.code === 200) {
        setMessageColor('text-success');
        setErrmsg(`${result2.status}`);
      } else {
        setMessageColor('text-danger');
        setErrmsg(`Something went wrong, please try again later.<br/>${result2.error}`);
      }
    } catch (error) {
      setMessageColor('text-danger');
      setErrmsg(error.message || String(error));
    }
    setSaveLoading(false);
  };

  const login = async (e) => {
    e.preventDefault();
    if (!validate()) {
      return;
    }

    setAuthLoading(true);

    try {
      await dispatch(authActions.login({ email, password })).unwrap();
      setShowForm(false);
    } catch (error) {
      const message = String(error?.message || error || '').trim();
      const normalizedMessage = message.toLowerCase();

      if (normalizedMessage.includes('password has not been set for this account')) {
        setForgotEmail(String(email || '').trim());
        setShowForgotPassword(true);
        setMessageColor('text-warning');
        setErrmsg('This account does not have a password yet. Use reset to set one now.');
        toast.info('Please set your password first. A reset email can be sent now.', { position: 'bottom-left' });
      }
    } finally {
      setAuthLoading(false);
    }
  };

  const validate = () => {
    let result = true;
    if (email === '' || email === null) {
      result = false;
      setAuthLoading(false);
      toast.warning('Please enter email', { position: 'bottom-left' });
    }
    if (password === '' || password === null) {
      result = false;
      setAuthLoading(false);
      toast.warning('Please enter Password', { position: 'bottom-left' });
    }
    return result;
  };

  if (!showForm) {
    return (
      <Button onClick={() => setShowForm(true)} variant='success' data-bs-theme={'dark'} className='menu-signout-btn'>
        Sign In
      </Button>
    );
  }

  return (
    <Container className='signin'>
      {showForgotPassword ? (
        <Form className='form'>
          <Row className="mt-2 mb-3">
            <Col>
              <Row className="mt-3 mb-3">
                <Col>
                  <Form.Control
                    className="formInput"
                    placeholder="email address*"
                    aria-label="email address*"
                    name="email"
                    value={forgotEmail}
                    onChange={e => setForgotEmail(e.target.value)}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col>
              <p className={messageColor}>{errmsg}</p>
            </Col>
          </Row>
          <Row className='d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8'>
            <Button variant='link' onClick={handleSignIn}>Do you want to sign in?</Button>
          </Row>
          <Row>
            <Col>
              {saveLoading
                ? <Button variant="primary" disabled style={{ width: '320px' }} className='mb-2'>Sending email...</Button>
                : <Button variant="primary" type="submit" style={{ width: '170px' }} className='mb-2' onClick={handleSubmit}>Send reset email</Button>
              }
            </Col>
            <Col>
              <Button variant="danger" onClick={() => { setShowForgotPassword(false); setShowForm(false); }} style={{ width: '100px' }}>Cancel</Button>
            </Col>
          </Row>
        </Form>
      ) : (
        <Form className='form'>
          <Row className='g-3 mb-9'>
            <Col>
              <Row className="mb-8">
                <Form.Control type="text" placeholder='Email' name='email' value={email} onChange={e => setEmail(e.target.value)} className='form-control bg-transparent mb-4' />
              </Row>
              <Row className='mb-10'>
                <PasswordInput placeholder='Password' name='password' value={password} onChange={e => setPassword(e.target.value)} className='form-control bg-transparent' />
              </Row>
              <Row className='d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-2'>
                <Button variant='link' onClick={handleForgotPassword}>Forgot password?</Button>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col>
              {authLoading
                ? <Button variant="primary" disabled>Signing In...</Button>
                : <Button variant="primary" type="submit" onClick={login}>Sign In</Button>
              }
            </Col>
            <Col>
              <Button variant="danger" onClick={() => setShowForm(false)} style={{ width: '100px' }}>Cancel</Button>
            </Col>
          </Row>
        </Form>
      )}
    </Container>
  );
};